import { render, staticRenderFns } from "./BranchDetail.vue?vue&type=template&id=14da5c53&scoped=true"
import script from "./BranchDetail.vue?vue&type=script&lang=js"
export * from "./BranchDetail.vue?vue&type=script&lang=js"
import style0 from "./BranchDetail.vue?vue&type=style&index=0&id=14da5c53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14da5c53",
  null
  
)

export default component.exports